import { render, staticRenderFns } from "./editOrgaInfo.vue?vue&type=template&id=18609a55&scoped=true"
import script from "./editOrgaInfo.vue?vue&type=script&lang=js"
export * from "./editOrgaInfo.vue?vue&type=script&lang=js"
import style0 from "./editOrgaInfo.vue?vue&type=style&index=0&id=18609a55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18609a55",
  null
  
)

export default component.exports